// Module
var code = "<div id=\"{{id}}\" class=\"form-group {{class}}\"> <label class=\"form-check-label\"> <input tabindex=\"{{tabIndex}}\" {{defaultValue}} type=\"checkbox\" name=\"{{name}}\"/> <span class=\"label\" data-i18n=\"{{labelI18n}}\">{{label}}</span> <sup class=\"require hide\">*</sup> </label> </div>";
// Exports
module.exports = code;